import React from "react";
import "./devNconst.scss";
const DevNConst = () => {
  return (
    <div className="developmentWrapper">
      <div className="developmentContent">
        <p>
          Development & <br /> Construction
        </p>
        <span className="dev-para">
          LANDEV excels in both the development and construction phases of real
          estate projects. Their approach encompasses meticulous planning,
          design, and approvals in the development phase, followed by precise
          construction management to ensure high-quality results. This
          end-to-end expertise guarantees the successful execution of their
          projects.
        </span>
        <div className="buildingNMaps">
            <div className="mainDiv"><div className="buildingName mb-2">RIGAUD- 33-35 Saint-Jean-Baptiste, Rigaud, Quebec</div> 
            <div className="buildingImg">
                <img src="/images/accomplishment/building1.png" alt="..." />
            </div>
            </div>

            <div className="mainDiv"><div className="buildingName mb-2">Industrial Building 126 270 SqFt</div> 
            <div className="buildingImg">
                <img src="/images/accomplishment/building1.png" alt="..." />
            </div>
            </div>


         
            
        </div>

        <div className="mainDiv2 mx-auto">
                <div className="buildingName2 mb-2">TROIS RIVIÈRES- 700 rue Notre Dame Est, Quebec</div> 
            <div className="buildingImg2">
                <img src="/images/accomplishment/building3.png" alt="..." />
            </div>
            </div>
      </div>
    </div>
  );
};

export default DevNConst;
